export const MESSAGE_CHANNELS = {
  email: { key: 'email', label: 'מייל', consentField: 'AlwEmail' },
  sms: { key: 'sms', label: 'SMS', consentField: 'U_AlwSms' },
  whatsapp: { key: 'whatsapp', label: 'WhatsApp', consentField: 'U_AlwWApp' },
};

export const MESSAGE_TEMPLATES = {
  invitation: {
    key: 'invitation',
    label: 'זימון',
    subject: 'זימון לביקור – {{שם_פרויקט}}',
    body: `שלום {{שם_דייר}} {{משפחה}},
פרויקט {{שם_פרויקט}}, דירה {{מספר_דירה}} בבניין {{בניין}}, טיפוס דירה: {{טיפוס}}

הנכם מוזמנים לבחירות דיירים
מוזמנים לבחור תאריך ושעה, מתוך הלוז הבא:

בברכה,
חברת טרבלסי
נשמח לעמוד לרשותכם`,
  },
  completion: {
    key: 'completion',
    label: 'סיום',
    subject: 'סיום – {{שם_פרויקט}}',
    body: `שלום {{שם_דייר}} {{משפחה}},

הבחירות דיירים בוצעו בהצלחה,
תודה שבחרתם בנו,
בברכה,
חברת טרבלסי`,
  },
};

export const PLACEHOLDER_HINTS = [
  { token: '{{שם_דייר}}', label: 'שם דייר' },
  { token: '{{משפחה}}', label: 'משפחה' },
  { token: '{{מספר_דירה}}', label: 'מספר דירה' },
  { token: '{{בניין}}', label: 'בניין' },
  { token: '{{טיפוס}}', label: 'טיפוס' },
  { token: '{{שם_קבלן}}', label: 'שם קבלן' },
  { token: '{{שם_פרויקט}}', label: 'שם פרויקט' },
];

export const SENT_MESSAGES_DEFAULT_COLUMNS = [
  { field: 'sentAt', label: 'תאריך שליחה', type: 'date' },
  { field: 'subject', label: 'נושא' },
  { field: 'templateType', label: 'סוג תבנית' },
  { field: 'sender', label: 'שולח' },
  { field: 'channels', label: 'ערוצים' },
  { field: 'recipientsTotal', label: 'נמענים', type: 'number' },
  { field: 'successCount', label: 'הצליחו', type: 'number' },
  { field: 'failedCount', label: 'נכשלו', type: 'number' },
  { field: 'status', label: 'סטטוס', type: 'status' },
];
